// extracted by css-extract-rspack-plugin
export default {"wrapper":"routes_wrapper__XqdQq","content":"routes_content__Jlr0Y"};